
// Get siteCode
export function getSiteCode() {

  const bodyClassList = document.querySelector('body').classList;
  let siteCode = '';

  for (let index = 0; index < bodyClassList.length; index++) {
    const item = bodyClassList[index];
    // console.log(item);
    if (item.includes('sitecode-')) {
      siteCode = item.replace('sitecode-', '');
      // console.log('siteCode:', siteCode);
    }
  }
  return siteCode;

}


// Get Blogs from localStorage
export function getStoredBlogs(siteCode) {
  const recentBlogsString = localStorage.getItem('recentBlogs-' + siteCode) || [];
  // console.log('string retrieved:', recentBlogsString);

  if (recentBlogsString.length < 1) {
    return [];  // returned empty
  }

  return JSON.parse(recentBlogsString);
}
